import { Moment } from "moment";
import { ChartGranularity } from "shared/enums/ChartGranularityEnum";
import ActionSummaryTagFilter from "./ActionSummaryTagFilter";
import SummaryChartGranularitySelect from "./SummaryChartGranularitySelect";

interface Props {
  tagItems: string[];
  selectedTagItems?: string[];
  onTagSelectionChange: (selectedTags: string[]) => void;
  onViewModeChange: (mode: string) => void;
  onFilterDateChange: (fromDate: Moment, toDate: Moment) => void;
  chartViewMode: ChartGranularity;
  fromDate: Moment;
  toDate: Moment;
}

export default function ActionSummaryFilter(props: Props) {
  const {
    tagItems,
    selectedTagItems,
    chartViewMode,
    fromDate,
    toDate,
    onTagSelectionChange,
    onViewModeChange,
    onFilterDateChange,
  } = props;

  return (
    <div>
      <div className="flex items-center">
        <div className="hidden lg:block mr-4">
          <div className="inline-block mr-3">filters:</div>
          <div className="inline-block">
            <ActionSummaryTagFilter
              tagItems={tagItems}
              selectedItems={selectedTagItems}
              onChange={onTagSelectionChange}
            />
          </div>
        </div>
        <div>
          <SummaryChartGranularitySelect
            onChange={onViewModeChange}
            viewMode={chartViewMode}
            fromDate={fromDate}
            toDate={toDate}
            onFilterDateChange={onFilterDateChange}
          />
        </div>
      </div>
    </div>
  );
}
